import { createI18n } from "vue-i18n";
import { getProperty, setProperty } from "dot-prop";
import { stripHtml } from "~/utils/miscellaneous";
import merge from "lodash/merge";
import envSelector from "~/lib/envSelector";
const mustache = require("mustache");
const LOCALE = "en";

let i18nMessages = window.keaConfig?.Language?.["unified-vue-mfe-content"];

let hostEnvConfig = envSelector.getEnvSelectorObj().selectedHostEnvConfig.value;

if (!i18nMessages) {
  console.warn(
    "can not get i18nMessages from window object, taking fallback i18nMessages from local"
  );

  const defaultLabels = require(`~/assets/locales/${LOCALE}/defaultLabels.json`);
  const tenantLabels = require(`~/assets/locales/${LOCALE}/tenantLabels.json`);
  i18nMessages = merge({}, defaultLabels, tenantLabels);
}

const messagesModifications = [
  {
    type: "mustacheExpr",
    messageKeys: [
      "labels.tenantName",
      "labels.tenantFullName",
      "labels.privacyPolicyUrl",
    ],
  },
  {
    type: "oneLine",
    messageKeys: [
      "htmlMarkup.helplineNo",
      "htmlMarkup.helplineWeekDays",
      "htmlMarkup.helplineTiming",
    ],
  },
];

function modifyMessages(messages, modificationConfig) {
  modificationConfig.forEach((config) => {
    switch (config.type) {
      /*'mustacheExpr' modification type will modify the value of provided messageKeys.
      It will resolve the mustache expression and host environment data will be provided in view (view is second argument of mustache.render method)*/
      /*config object format for 'mustacheExpr' modification is
      {
        type: "mustacheExpr",
        messageKeys: Array<string> //will have list of messageKeys to modify
      }
      */
      case "mustacheExpr":
        config.messageKeys.forEach((messageKey) => {
          setProperty(
            messages,
            messageKey,
            mustache.render(getProperty(messages, messageKey), {
              hostEnv: hostEnvConfig,
            })
          );
        });
        break;
      /*'oneLine' modification type will modify the value of provided messageKeys.
      It will replace the spaces in message value with '&nbsp;'*/
      /*config object format for 'oneLine' modification is
      {
        type: "oneLine",
        messageKeys: Array<string> //will have list of messageKeys to modify
      }
      */
      case "oneLine":
        config.messageKeys.forEach((messageKey) => {
          setProperty(
            messages,
            messageKey,
            getProperty(messages, messageKey).replace(/\s+/g, "&nbsp;")
          );
        });
        break;
    }
  });
  return messages;
}

const modifiers = {
  stripHtml,
};

export default createI18n({
  legacy: false,
  locale: LOCALE,
  fallbackLocale: LOCALE,
  warnHtmlMessage: false,
  modifiers,
  messages: {
    [LOCALE]: modifyMessages(i18nMessages, messagesModifications),
  },
});
